(function () {
  var MOBILE_QUERY = '(max-width: 767px)';
  var CHAT_SELECTOR = 'inbox-online-store-chat#ShopifyChat';
  var TOOLBAR_SELECTOR = '#shopify-section-toolbar_mobile';
  var GAP = 12;
  var watcher = null;
  var scheduled = false;

  function isMobile() {
    return window.matchMedia(MOBILE_QUERY).matches;
  }

  function getToolbarHeight() {
    var toolbar = document.querySelector(TOOLBAR_SELECTOR);
    if (!toolbar) return 55;

    var rect = toolbar.getBoundingClientRect();
    return Math.max(55, Math.round(rect.height || 55));
  }

  function setToolbarHidden(hidden) {
    var toolbar = document.querySelector(TOOLBAR_SELECTOR);
    if (!toolbar) return;

    if (hidden) {
      toolbar.style.setProperty('visibility', 'hidden', 'important');
      toolbar.style.setProperty('pointer-events', 'none', 'important');
    } else {
      toolbar.style.removeProperty('visibility');
      toolbar.style.removeProperty('pointer-events');
    }
  }

  function setChatStyle(chat, declarations) {
    var styleText = declarations.join('; ') + ';';
    if (chat.getAttribute('style') === styleText) return;

    chat.setAttribute('style', styleText);
  }

  function getViewportHeightValue() {
    return window.CSS && CSS.supports('height', '100dvh') ? '100dvh' : '100vh';
  }

  function applyChatPosition() {
    scheduled = false;

    var chat = document.querySelector(CHAT_SELECTOR);
    if (!chat) {
      setToolbarHidden(false);
      return;
    }

    if (!isMobile()) {
      setToolbarHidden(false);
      return;
    }

    var isOpen = chat.getAttribute('is-open') === 'true';

    if (isOpen) {
      var viewportHeight = getViewportHeightValue();
      setChatStyle(chat, [
        'position: fixed !important',
        'inset: 0 !important',
        'top: 0 !important',
        'right: 0 !important',
        'bottom: 0 !important',
        'left: 0 !important',
        'width: auto !important',
        'max-width: none !important',
        'height: ' + viewportHeight + ' !important',
        'max-height: ' + viewportHeight + ' !important',
        'z-index: 2147483647 !important',
        'transform: none !important',
        'overflow: hidden !important'
      ]);
      setToolbarHidden(true);
      return;
    }

    var bottomOffset = 'calc(' + (getToolbarHeight() + GAP) + 'px + env(safe-area-inset-bottom))';
    setChatStyle(chat, [
      'position: fixed !important',
      'bottom: ' + bottomOffset + ' !important',
      'right: max(12px, env(safe-area-inset-right)) !important',
      'left: auto !important',
      'height: 65px !important',
      'z-index: 2147483000 !important',
      'transform: none !important'
    ]);
    setToolbarHidden(false);
  }

  function scheduleApply() {
    if (scheduled) return;

    scheduled = true;
    window.requestAnimationFrame(applyChatPosition);
  }

  function watchChat() {
    var chat = document.querySelector(CHAT_SELECTOR);
    if (!chat) {
      scheduleApply();
      return;
    }

    if (watcher) watcher.disconnect();
    watcher = new MutationObserver(scheduleApply);
    watcher.observe(chat, {
      attributes: true,
      attributeFilter: ['is-open', 'is-mobile', 'style']
    });
    scheduleApply();
  }

  function init() {
    watchChat();

    var bodyWatcher = new MutationObserver(function () {
      if (document.querySelector(CHAT_SELECTOR)) watchChat();
    });
    bodyWatcher.observe(document.documentElement, {
      childList: true,
      subtree: true
    });

    window.addEventListener('resize', scheduleApply, { passive: true });
    window.addEventListener('orientationchange', scheduleApply, { passive: true });

    [300, 1000, 2500, 5000].forEach(function (delay) {
      window.setTimeout(scheduleApply, delay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
}());
